// Design tokens da tela de Templates WhatsApp.
// Referência: .md/DESIGN_UIUX.md (Painel de Configurações).
//
// Linguagem visual:
// - Neutros zinc (#18181b → #a1a1aa) sobre fundo #f4f4f7; roxo (#6d28d9)
//   só como acento — ação primária, seleção, links.
// - Cor semântica comunica estado; nunca decora.
// - Largura total da área principal (full-bleed) — sem card-shell / max-width.
// - Header sticky flat (branco + border-b), sem radius.
// - Hierarquia por cabeçalho de seção (rótulo uppercase fora do cartão).
// - Preview WhatsApp: cores de produto (#d9fdd3, #008069) — exceção documentada.

export const TEMPLATES_WHATSAPP_DESIGN = {
  // ---------- shell ----------
  root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pb-[120px]',

  // ---------- barra de topo ----------
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
  topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  iconTile:
    'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
  // Ícone de produto WhatsApp (verde Meta) — exceção de marca, não de UI.
  iconTileWhatsapp:
    'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ecfdf3] text-[#067647]',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
  backButton:
    'flex items-center justify-center flex-shrink-0 w-[34px] h-[34px] mt-[3px] rounded-lg bg-transparent text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',

  // ---------- cabeçalho de seção ----------
  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  // ---------- cartões ----------
  stack: 'flex flex-col gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',
  cardTitle: 'text-[15px] font-semibold text-[#18181b]',
  cardSubtitle: 'mt-0.5 text-[13px] text-[#71717a] leading-[1.5]',
  divider: 'h-px bg-[#f0f0f3]',

  // ---------- filtros ----------
  filtersGrid: 'grid grid-cols-1 md:grid-cols-3 gap-6',
  field: 'min-w-0',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  inputDisabled: 'bg-[#fafafb] cursor-not-allowed text-[#71717a]',
  inputSearch:
    'w-full box-border h-auto pl-9 pr-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  select:
    'w-full box-border h-auto min-h-[44px] px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] md:text-[14px] font-normal text-[#18181b] shadow-none transition-colors hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
  textarea:
    'w-full box-border px-4 py-3.5 rounded-lg border border-[#d4d4d8] bg-white text-[14px] leading-[1.6] text-[#18181b] shadow-none resize-y transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  searchIcon: 'absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',

  // ---------- botões ----------
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  dangerButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#b42318] whitespace-nowrap transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca] disabled:opacity-50 disabled:cursor-not-allowed',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',

  // ---------- badges ----------
  badge:
    'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap flex-shrink-0 border',
  badgeOk: 'bg-[#ecfdf3] text-[#067647] border-[#abefc6]',
  badgeDanger: 'bg-[#fef3f2] text-[#b42318] border-[#fecdca]',
  badgeWarn: 'bg-[#fffaeb] text-[#b54708] border-[#fedf89]',
  badgeNeutral: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  badgeSoft: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',
  badgeDot: 'w-1.5 h-1.5 rounded-full',
  badgeDotOk: 'bg-[#17b26a]',
  badgeDotDanger: 'bg-[#f04438]',
  badgeDotWarn: 'bg-[#f79009]',
  badgeDotNeutral: 'bg-[#d4d4d8]',

  // categorias de template (derivadas da paleta — sem cores novas)
  categoryUtility: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  categoryMarketing: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',
  categoryAuth: 'bg-[#fffaeb] text-[#b54708] border-[#fedf89]',

  // ---------- tabela ----------
  tableWrap: 'w-full overflow-x-auto min-w-0',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',
  tableRow: 'border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb]',
  tableIcon:
    'flex items-center justify-center w-9 h-9 rounded-lg bg-[#ecfdf3] text-[#067647] flex-shrink-0',
  langChip: 'text-[11px] text-[#71717a] bg-[#f4f4f5] border border-[#e7e7ec] rounded-md px-2 py-0.5',

  // ---------- empty / notice ----------
  emptyState: 'px-2 py-10 text-center',
  emptyIcon:
    'mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  noticeInfo: 'px-4 py-3.5 rounded-[10px] border border-[#e7e7ec] bg-[#fafafb] text-[13px] text-[#71717a] leading-[1.5]',
  noticeWarn:
    'flex items-start gap-3 px-4 py-3.5 rounded-[10px] border border-[#fedf89] bg-[#fffaeb] text-[13px] text-[#b54708] leading-[1.5]',
  loadingBar: 'h-1 bg-[#f4f4f5] rounded-full overflow-hidden',
  loadingBarInner: 'h-full bg-[#6d28d9] rounded-full animate-[pulse_1.5s_ease-in-out_infinite]',
  logsBadge:
    'absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-[#b42318] text-white text-[10px] font-bold rounded-full px-1',

  // ---------- stats ----------
  statsGrid: 'grid grid-cols-2 md:grid-cols-4 gap-3.5',
  statsCard: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[18px] flex items-center gap-3 overflow-hidden min-w-0',
  statsIcon: 'flex items-center justify-center w-10 h-10 rounded-[10px] flex-shrink-0',
  statsIconSoft: 'bg-[#ede9fe] text-[#6d28d9]',
  statsIconOk: 'bg-[#ecfdf3] text-[#067647]',
  statsIconWarn: 'bg-[#fffaeb] text-[#b54708]',
  statsIconDanger: 'bg-[#fef3f2] text-[#b42318]',
  statsValue: 'text-[20px] font-bold text-[#18181b] leading-none',
  statsLabel: 'mt-1 text-[12px] text-[#71717a]',

  // ---------- drawer / sheet ----------
  drawerOverlay: 'fixed inset-0 z-[9999] flex justify-end overflow-hidden animate-in fade-in duration-200',
  drawerBackdrop: 'absolute inset-0 bg-black/40 backdrop-blur-[2px]',
  drawerPanel:
    'relative w-[90%] max-w-7xl h-full bg-white border-l border-[#e7e7ec] flex flex-col animate-in slide-in-from-right duration-300',
  drawerHeader: 'flex items-center justify-between px-[26px] py-[18px] border-b border-[#e7e7ec] bg-white',
  drawerHeaderIcon:
    'flex items-center justify-center w-9 h-9 rounded-[10px] flex-shrink-0',
  drawerHeaderIconCreate: 'bg-[#ede9fe] text-[#6d28d9]',
  drawerHeaderIconView: 'bg-[#ecfdf3] text-[#067647]',
  drawerHeaderIconLibrary: 'bg-[#f4f4f5] text-[#71717a]',
  drawerTitle: 'text-[15px] font-semibold text-[#18181b]',
  drawerSubtitle: 'mt-0.5 text-[13px] text-[#71717a]',
  drawerError:
    'flex items-start gap-3 px-[26px] py-3 bg-[#fef3f2] border-b border-[#fecdca] text-[13px] text-[#b42318]',
  drawerBody: 'flex-1 flex overflow-hidden min-h-0',
  drawerLeft: 'w-[62%] p-[26px] overflow-y-auto max-h-full border-r border-[#f0f0f3] bg-white',
  drawerRight: 'w-[38%] p-[26px] overflow-y-auto max-h-full bg-[#fafafb]',
  drawerFooter: 'border-t border-[#e7e7ec] bg-[#fafafb] px-[26px] py-4 flex items-center justify-between',
  drawerSection: 'mb-6',
  drawerSectionHead: 'flex items-center gap-3 mb-5',
  drawerSectionIcon:
    'flex items-center justify-center w-8 h-8 rounded-lg bg-[#ede9fe] text-[#6d28d9]',
  drawerSectionTitle: 'text-[15px] font-semibold text-[#18181b]',
  drawerSectionLabel: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',

  // ---------- biblioteca ----------
  libraryGrid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3.5',
  libraryCard:
    'group cursor-pointer bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 transition-colors hover:border-[#a78bfa]',
  libraryCardTitle: 'text-[14px] font-semibold text-[#18181b] leading-tight',
  libraryCardDesc: 'text-[12px] text-[#71717a] line-clamp-2 leading-relaxed',
  libraryCardFooter: 'mt-3 pt-3 border-t border-[#f0f0f3]',
  libraryUse: 'text-[12px] text-[#6d28d9] font-semibold group-hover:underline',

  // ---------- preview WhatsApp (cores de produto) ----------
  previewPhoneFrame: 'bg-[#18181b] rounded-[2.5rem] p-1.5 mx-auto max-w-[300px]',
  previewPhoneInner: 'bg-[#18181b] rounded-[2rem] overflow-hidden',
  previewNotch: 'flex justify-center py-2 bg-[#18181b]',
  previewNotchPill: 'w-20 h-5 bg-[#27272a] rounded-full',
  previewWhatsappHeader: 'bg-[#008069] px-3 py-2.5 flex items-center gap-2.5',
  previewChatArea: 'min-h-[320px] p-3',
  previewMessageBubble:
    'bg-[#d9fdd3] rounded-xl rounded-tr-sm p-2.5 shadow-[0_1px_2px_rgba(24,24,27,.08)] max-w-[88%] min-w-[160px] relative ml-auto',
  previewMessageTail:
    'absolute -right-1 top-0 w-0 h-0 border-l-[8px] border-l-[#d9fdd3] border-t-[8px] border-t-transparent',
  previewInputBar: 'bg-[#f0f0f0] px-2 py-2 flex items-center gap-2',
  previewHomeIndicator: 'flex justify-center py-2 bg-[#18181b]',
  previewVar:
    'inline bg-blue-100/80 text-blue-700 rounded text-[10px] font-semibold px-0.5',

  // aliases legados (consumidores que ainda usam a árvore antiga)
  page: {
    container: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
    header: {
      container: 'flex flex-col md:flex-row md:items-start gap-4',
      title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
      subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
    },
    actionButton:
      'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  },
  stats: {
    grid: 'grid grid-cols-2 md:grid-cols-4 gap-3.5',
    card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[18px] flex items-center gap-3 overflow-hidden min-w-0',
    iconBox: 'flex items-center justify-center w-10 h-10 rounded-[10px] flex-shrink-0',
    value: 'text-[20px] font-bold text-[#18181b] leading-none',
    label: 'mt-1 text-[12px] text-[#71717a]',
  },
  filters: {
    grid: 'grid grid-cols-1 md:grid-cols-3 gap-6',
    label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
    select:
      'w-full box-border h-auto min-h-[44px] px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] font-normal text-[#18181b] shadow-none transition-colors hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
    searchInput:
      'w-full box-border h-auto pl-9 pr-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  },
  drawer: {
    backdrop: 'absolute inset-0 bg-black/40 backdrop-blur-[2px]',
    container:
      'relative w-[90%] max-w-7xl h-full bg-white border-l border-[#e7e7ec] flex flex-col animate-in slide-in-from-right duration-300',
    header: {
      container: 'flex items-center justify-between px-[26px] py-[18px] border-b border-[#e7e7ec] bg-white',
      title: 'text-[15px] font-semibold text-[#18181b]',
      subtitle: 'mt-0.5 text-[13px] text-[#71717a]',
      actions: 'flex items-center gap-3',
    },
    content: {
      container: 'flex-1 flex overflow-hidden min-h-0',
      leftColumn: 'w-[62%] p-[26px] overflow-y-auto max-h-full border-r border-[#f0f0f3] bg-white',
      rightColumn: 'w-[38%] p-[26px] overflow-y-auto max-h-full bg-[#fafafb]',
      section: {
        container: 'mb-6',
        titleWrapper: 'flex items-center gap-3 mb-5',
        iconBox: 'flex items-center justify-center w-8 h-8 rounded-lg bg-[#ede9fe] text-[#6d28d9]',
        title: 'text-[15px] font-semibold text-[#18181b]',
        label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
        input: {
          base: 'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd]',
          disabled: 'bg-[#fafafb] cursor-not-allowed text-[#71717a]',
        },
      },
    },
    footer: {
      container: 'border-t border-[#e7e7ec] bg-[#fafafb] px-[26px] py-4 flex items-center justify-between',
    },
    preview: {
      phoneFrame: 'bg-[#18181b] rounded-[2.5rem] p-1.5 mx-auto max-w-[300px]',
      phoneInner: 'bg-[#18181b] rounded-[2rem] overflow-hidden',
      notch: 'flex justify-center py-2 bg-[#18181b]',
      notchPill: 'w-20 h-5 bg-[#27272a] rounded-full',
      whatsappHeader: 'bg-[#008069] px-3 py-2.5 flex items-center gap-2.5',
      chatArea: 'min-h-[320px] p-3',
      messageBubble:
        'bg-[#d9fdd3] rounded-xl rounded-tr-sm p-2.5 shadow-[0_1px_2px_rgba(24,24,27,.08)] max-w-[88%] min-w-[160px] relative ml-auto',
      messageTail:
        'absolute -right-1 top-0 w-0 h-0 border-l-[8px] border-l-[#d9fdd3] border-t-[8px] border-t-transparent',
      inputBar: 'bg-[#f0f0f0] px-2 py-2 flex items-center gap-2',
      homeIndicator: 'flex justify-center py-2 bg-[#18181b]',
    },
  },
  card: {
    container:
      'group cursor-pointer bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 transition-colors hover:border-[#a78bfa]',
  },
};

export default TEMPLATES_WHATSAPP_DESIGN;
